import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="422.4" height="422.4" viewBox="0 0 422.4 422.4" {...props}><path d="M268.3 210.7L421.4 57.6 364.9 1 211.7 154.1 57.6 0 1 56.6l154.1 154.1L0 365.9l56.6 56.5 155.1-155.1 154.2 154.1 56.5-56.5z" /></svg>);